'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dGlobals$0024 from "./presto.-Globals$.js";
var $p;
/** @constructor */
function $c_Lpresto_types$SingleAppToken(created, expires, user) {
  this.YC = null;
  this.YD = null;
  this.fy = null;
  this.YC = created;
  this.YD = expires;
  this.fy = user;
}
export { $c_Lpresto_types$SingleAppToken as $c_Lpresto_types$SingleAppToken };
$p = $c_Lpresto_types$SingleAppToken.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$SingleAppToken;
/** @constructor */
function $h_Lpresto_types$SingleAppToken() {
}
export { $h_Lpresto_types$SingleAppToken as $h_Lpresto_types$SingleAppToken };
$h_Lpresto_types$SingleAppToken.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$SingleAppToken)) {
    var x = this.YC;
    var x$2 = x$0.YC;
    if (((x === null) ? (x$2 === null) : x.i(x$2))) {
      var x$3 = this.YD;
      var x$4 = x$0.YD;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.fy;
      var x$6 = x$0.fy;
      return ((x$5 === null) ? (x$6 === null) : x$5.i(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 3;
});
$p.s = (function() {
  return "SingleAppToken";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.YC;
      break;
    }
    case 1: {
      return this.YD;
      break;
    }
    case 2: {
      return this.fy;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.cJv = (function(code) {
  return this.fy.u1.xa.cK(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$9) => _$9.DA))).aE(code);
});
$p.cOx = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sc_IterableOnceOps__mkString__T__T__T__T(this.fy.u1.xa.cK(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$10) => _$10.DA))).a3(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((t) => t))), "", ", ", "");
});
$p.ae1 = (function() {
  var this$1 = this.fy.h9.ja;
  var b = $j_presto$002e$002dGlobals$0024.$m_Lpresto_Globals$().mW;
  return ((this$1.e === b.e) && (this$1.f === b.f));
});
$p.cEK = (function() {
  return this.fy.u1.xb.cK(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$11) => _$11.KP)));
});
$p.adR = (function(code) {
  return this.fy.u1.xb.hm(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$13) => (_$13.KO === code))));
});
$p.zl = (function(code) {
  return this.cEK().hm(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$14) => (_$14.KN === code))));
});
function $isArrayOf_Lpresto_types$SingleAppToken(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ke)));
}
export { $isArrayOf_Lpresto_types$SingleAppToken as $isArrayOf_Lpresto_types$SingleAppToken };
var $d_Lpresto_types$SingleAppToken = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$SingleAppToken, "presto.types$SingleAppToken", ({
  ke: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$SingleAppToken as $d_Lpresto_types$SingleAppToken };
//# sourceMappingURL=presto.types$-Single-App-Token.js.map
